export default __webpack_public_path__ + "static/media/back11en.35e5003e.png";